import * as React from "react";
import type { SVGProps } from "react";
const SvgZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#zoom-in_svg__a)">
      <path d="M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6" />
      <path d="M21 22c-.26 0-.51-.1-.71-.29l-6-6a.996.996 0 1 1 1.41-1.41l6 6a.996.996 0 0 1-.71 1.7zM10 14.5c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1" />
      <path d="M13.5 11h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="zoom-in_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgZoomIn;
